import { isBefore } from 'date-fns'

import type { TGetPlantasBlocoResponse } from '@/features/plantas/interfaces/planta.types'

export class PlantasBloco {
  private readonly plantas: TGetPlantasBlocoResponse

  constructor(plantas: TGetPlantasBlocoResponse) {
    this.plantas = plantas
  }

  isDataAlvenariaAnteriorHoje(data?: string | null): boolean {
    if (!data) return false
    return isBefore(new Date(data), new Date(new Date().setHours(0, 0, 0, 0)))
  }

  getPrimeiraPlantaDoBloco(): TGetPlantasBlocoResponse[number] {
    return this.plantas[0]!
  }
}
